import { render } from "./SectionBooking.vue?vue&type=template&id=59b2cc09&scoped=true"
import script from "./SectionBooking.vue?vue&type=script&lang=js"
export * from "./SectionBooking.vue?vue&type=script&lang=js"

import "./SectionBooking.vue?vue&type=style&index=0&id=59b2cc09&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b2cc09"]])

export default __exports__